module.exports = __webpack_public_path__ + "static/media/folder-open-icon.52ef37f8.svg";